var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',{attrs:{"cols":"12","md":"4"}},[_c('statistics-guests-card')],1),_c('b-col',{attrs:{"cols":"12","md":"8"}},[_c('statistics-insights-card'),_c('statistics-billing-card')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }